import type {
  TCalendarRootProps,
} from "@/ui/components/form/Calendar/Calendar.config";
import { cn } from "@/ui/lib/utils";

export const CalendarRoot = ({
  className,
  rootRef,
  ...props
}: TCalendarRootProps) => (
  <div
    {...props}
    ref={rootRef}
    data-component="Calendar"
    className={cn(
      "rounded-sys-sm bg-sys-neutral-300",
      className,
    )}
  />
);

CalendarRoot.displayName = "CalendarRoot";
